// import abi from "./Transactions.json";

// export const contractAddress = "0xfCCF80344a668b72ac4Be23513F0E9E4a35C84fA";
// export const contractABI = abi.abi;
import abi from "./Transactions.json";
import abi2 from "./NFTMarket.json";
import abi3 from "./NFT.json";

export const contractABI = abi.abi;
export const nftmarketABI = abi2.abi;
export const nftaddressABI = abi3.abi;
export const contractAddress = "0x5FbDB2315678afecb367f032d93F642f64180aa3";
export const nftmarketaddress = "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512";
export const nftaddress = "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0";
